module.exports = __webpack_public_path__ + "img/neg-z.aaf16ebe.png";